const { getChoiceOptionForModel } = useFieldConfigs();
const BLANK_OPTION: ChoiceOption = { value: '', text: '' };

/**
 * Gets the list of fields for the Vehicle embedded form.
 */
const getVehicleFormConfig = (): FieldConfig[] => {
  return [
    {
      id: 'id',
      label: 'Id',
      type: 'number',
      hidden: true,
    },
    {
      id: 'license_plate_state',
      label: 'License State',
      type: 'text',
      cols: 4,
    },
    {
      id: 'license_plate',
      label: 'License Plate',
      type: 'text',
      cols: 8,
    },
    {
      id: 'vin',
      label: 'VIN',
      type: 'text',
      cols: 12,
      maxLength: 19,
    },
    {
      id: 'year',
      label: 'Year',
      type: 'text',
      cols: 2,
    },
    {
      id: 'color',
      label: 'Color',
      type: 'text',
      cols: 3,
    },
    {
      id: 'make',
      label: 'Make',
      type: 'text',
      cols: 3,
    },
    {
      id: 'model',
      label: 'Model',
      type: 'text',
      cols: 4,
    },
    {
      id: 'description',
      label: 'Description',
      type: 'text',
      cols: 12,
    },
  ];
};

// TODO: Configure to retrieve only active investigations on active incidents.
const getVehicleChoiceFieldConfig = async (investigationReportId: number): Promise<FieldConfig> => {
  const { getAllVehicles } = useApi();
  const vehicleOptions = await getChoiceOptionForModel(
    async () => (await getAllVehicles(investigationReportId)).results,
    vehicle => ({
      value: vehicle.id,
      text: getVehicleDescription(vehicle),
    }),
    BLANK_OPTION,
  );

  return {
    id: 'vehicle',
    label: 'Vehicle',
    type: 'choice',
    clearable: true,
    options: vehicleOptions,
  };
};

/**
 * Returns a map of functions for retrieving lists of fields for various forms.
 */
export const useFieldConfigsVehicle = () => ({
  getVehicleChoiceFieldConfig,
  getVehicleFormConfig,
});
